import { connect } from 'react-redux';
import Header from './Header';
import { loadLocale } from 'reducers/locale';

const mapDispatchToProps = {
  loadLocale
};

const mapStateToProps = ({ locale }) => ({
  locale
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
